import { gql } from "@apollo/client"

export const GET_USP_CAROUSEL = gql`
  query uspCarousel($id: String!) {
    uspCarousel(id: $id) {
      color
      uspsCollection {
        items {
          title
          label
          imagesCollection {
            items {
              title
              description
              url
            }
          }
          content {
            json
          }
        }
      }
    }
  }
`
